import { basketActions } from './basket/basket.slice';
import * as cardAsyncActions from './card/card.actions';
import { cardActions } from './card/card.slice';
import * as catalogAsyncActions from './catalog/catalog.actions';
import { catalogActions } from './catalog/catalog.slice';
import { favoriteActions } from './favorite/favorite.slice';
import { layoutActions } from './layout/layout.slice';
import * as mainAsyncActions from './main/main.actions';
import { publicationActions } from './publication/publication.slice';
import * as reviewAsyncActions from './review/review.actions';
import { reviewActions } from './review/review.slice';
import * as searchAsyncActions from './search/search.actions';
import { searchActions } from './search/search.slice';
import * as userAsyncActions from './user/user.actions';
import { userActions } from './user/user.slice';

export const allActions = {
  ...userActions,
  ...basketActions,
  ...cardActions,
  ...layoutActions,
  ...catalogActions,
  ...publicationActions,
  ...searchActions,
  ...userActions,
  ...reviewActions,
  ...favoriteActions,
  ...reviewAsyncActions,
  ...cardAsyncActions,
  ...mainAsyncActions,
  ...searchAsyncActions,
  ...catalogAsyncActions,
  ...userAsyncActions,
};
